import {Button, Image} from '@chakra-ui/react';
import {useAuth} from 'hooks';
import {FC, MouseEvent} from 'react';
import {colors} from 'theme';
import {ICustomerAddToFavoritesRequest} from 'types';

interface IProps {
  isFavorite?: boolean;
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  data: ICustomerAddToFavoritesRequest;
}

export const FavouriteIndicator: FC<IProps> = ({data, onEditFavorite, isFavorite}) => {
  const {isAuthenticated} = useAuth();

  const addFavorites = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onEditFavorite(data);
  };

  return (
    <>
      {isAuthenticated && (
        <Button
          variant="favorite"
          //disabled={!isFavorite}
          onClick={(e) => addFavorites(e)}
          w={['25px', '32px']}
          h={['25px', '32px']}
          minW="unset"
        >
          <Image
            w={['15px', '24px']}
            h={['15px', '24px']}
            src={isFavorite ? '/active-favorite-btnYandex.svg' : '/favorite-btnYandex.svg'}
            alt="favorite"
            fill={colors.white}
          />
        </Button>
      )}
    </>
  );
};
